import{a as o}from"./chunk-UMYX3T5O.js";import{j as t,m as n}from"./chunk-HBP5N4FR.js";n();function a(r){return t(this,null,function*(){return yield o(r)})}export{a};
//# sourceMappingURL=chunk-NUPRGV3A.js.map
